// Font - Style
const FontHeader = {
    fontSize: "1.75rem",
    fontWeight: 600,
    color: "#00A8A9"
}

const FontSubHeader = {
    fontSize: "1.5rem",
    fontWeight: 500,
    color: "#000000"
}

const FontTopic = {
    fontSize: "1rem",
    fontWeight: 500,
    color: "#000000",
    marginBottom : 0.5
}

const FontParagraph = {
    fontSize: "1rem",
    color: "#000000"
}

const FontComment = {
    fontSize: "0.875rem",
    color : "#B6B6B6"
}

const FontNavbarProjectName = {
    flexGrow: 1,
    width: "auto",
    height: "100%",
    fontWeight: 600,
    fontSize: { xs: "0.8rem", sm: "1.1rem", md: "1.3rem" },
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
}

const FontNavbarParagraph = {
    flexGrow: 1,
    width: "auto",
    height: "100%",
    fontSize: { xs: "0.7rem", sm: "1.0rem", md: "1rem" },
    fontWeight : 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
}

const FontSideBarHeader = {
    fontSize: "1.3125rem",
    color: "#ED6F2D",
    fontWeight: 600
}

const FontSideBarParagraph = {
    fontSize: "1rem",
    color: "#000000DE",
    fontWeight: 600
}

const FontHeaderPrevious = {
    fontSize: "1.75rem",
    fontWeight: 600,
    color: "#B6B6B6"
}

// Modal style
const InformationModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: {xs:350,sm:600,md:750},
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: "600px",
    overflowY: "auto",
    overflowX: "hidden",
};

// Button - style
const DefaultPrimaryButton = {
    backgroundColor: '#00A8A9',
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    color : '#ffffff',
    fontSize : "1rem",
}

const DefaultSecondaryButton = {
    backgroundColor: '#FFFFFF',
    borderColor : "#00A8A9",
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    fontSize : "1rem",
    color : "#00A8A9",
}

const DefaultSecondaryVisibilityButton = {
    backgroundColor: '#FFFFFF',
    borderColor : "#00A8A9",
    paddingLeft : 0,
    paddingRight : 0,
    color : "#00A8A9",
}

const NormalSecondaryButton = {
    backgroundColor: '#FFFFFF',
    borderColor : "#B6B6B6",
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    fontSize : "1rem",
    color : "#B6B6B6",
}

const SuccessPrimaryButton = {
    backgroundColor : '#4CAF50',
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    color : '#ffffff',
    fontSize : "1rem",
}

const SuccessPrimaryApproveButton = {
    backgroundColor : '#4CAF50',
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    color : '#ffffff',
    fontSize : "1rem",
}

const RejectPrimaryButton = {
    backgroundColor : '#ED4D4D',
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    color : '#ffffff',
    fontSize : "1rem",
}

const RejectPrimaryNotApproveButton = {
    backgroundColor : '#ED4D4D',
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    color : '#ffffff',
    fontSize : "1rem",
}

const RejectPrimaryDeleteButton = {
    backgroundColor : '#ED4D4D',
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    color : '#ffffff',
    fontSize : "1rem",
}

const EditPrimaryButton = {
    backgroundColor: "#EDAA4D",
    paddingLeft : {xs :2, sm:2, md:3},
    paddingRight : {xs :2, sm:2, md:3},
    color : '#ffffff',
    fontSize : "1rem",
}

const ToggleInfoButton = {
    "& .MuiToggleButton-root": {
        bgcolor: "#ffffff",
        color: "#000000",
        "&.Mui-selected": {
            bgcolor: "#00A8A9",
            color: "#ffffff",
        },
        "&:hover": {
            bgcolor: "rgba(0, 168, 169, 0.5)",
        },
        },
    }

const ToggleInfoFullWidthButton = {
    "& .MuiToggleButton-root": {
        bgcolor: "#ffffff",
        color: "#000000",
        "&.Mui-selected": {
            bgcolor: "#00A8A9",
            color: "#ffffff",
        },
        "&:hover": {
            bgcolor: "rgba(0, 168, 169, 0.5)",
        },
        },
    width : '100%'
    }

const DocumentUnderlineButton = {
    backgroundColor: "transparent",
    color: "#136BF0",
    textTransform: "none",
    textDecoration: "underline",
    "&:hover": {
    backgroundColor: "transparent",
    textDecoration: "none",
    },
}

const RadioButton = {
    "&.Mui-checked": {
        color: "#00A8A9",
    },
}

const CheckButton = {
    "&.Mui-checked": {
        color: "#00A8A9",
    },
}

const SwitchButton = {
    "& .MuiSwitch-switchBase.Mui-checked": {
      color: "#00A8A9",
    },
    "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#00A8A9",
    },
}

// Input - style
const InputTextField = {
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        borderColor: '#B6B6B6',
        },
        '&:hover fieldset': {
        borderColor: '#00A8A9', 
        },
        '&.Mui-focused fieldset': {
        borderColor: '#00A8A9',
        },
    },
}

const InputNumberTextField = {
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        borderColor: '#B6B6B6',
        },
        '&:hover fieldset': {
        borderColor: '#00A8A9', 
        },
        '&.Mui-focused fieldset': {
        borderColor: '#00A8A9',
        },
    },
}

const InputTextArea = {
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
        borderColor: '#B6B6B6',
        },
        '&:hover fieldset': {
        borderColor: '#00A8A9', 
        },
        '&.Mui-focused fieldset': {
        borderColor: '#00A8A9',
        },
    },
}

const OutlinedInputTextField = {
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00A8A9",
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
        borderColor: "#00A8A9",
    },
}

const InputSelect = {
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#00A8A9', 
        },
        '&:hover .MuiOutlinedInput-notchedOutline': {
        borderColor: '#00A8A9',
        },
        '& .MuiOutlinedInput-notchedOutline': {
        borderColor: '#B6B6B6',
        }
}


export { FontHeader, FontSubHeader, FontComment, FontParagraph, FontTopic,
        FontNavbarParagraph, FontNavbarProjectName, FontSideBarHeader, FontSideBarParagraph,
    InformationModal,
    DefaultPrimaryButton, DefaultSecondaryButton, NormalSecondaryButton, ToggleInfoButton, ToggleInfoFullWidthButton, DefaultSecondaryVisibilityButton, OutlinedInputTextField, EditPrimaryButton,
    SuccessPrimaryButton,SuccessPrimaryApproveButton, RejectPrimaryButton, RejectPrimaryDeleteButton, RejectPrimaryNotApproveButton, DocumentUnderlineButton, RadioButton, CheckButton,
    InputTextField, InputSelect, InputNumberTextField, InputTextArea,
    SwitchButton, FontHeaderPrevious}